import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglecalendarComponent } from './simple-icons-googlecalendar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglecalendarComponent ],
    exports:      [ SimpleIconsGooglecalendarComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglecalendarModule {}
